import { render, staticRenderFns } from "./FullscreenMedia.vue?vue&type=template&id=9673f3ee&scoped=true&"
import script from "./FullscreenMedia.vue?vue&type=script&lang=js&"
export * from "./FullscreenMedia.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenMedia.vue?vue&type=style&index=0&id=9673f3ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9673f3ee",
  null
  
)

export default component.exports